import React from 'react';
import './initative.css';
import pn1 from '../images/1.png';
import pn2 from '../images/2.png';
import pn3 from '../images/3.png';
import pn4 from '../images/4.png';
import pn5 from '../images/5.png';
import pn6 from '../images/6.png';

const Initative = () => {
    return (
        <div>
            <div className='initative'>
                <div className='wraper'>
                    <h1>Initiative</h1>
                </div>
                <div className='big-b'>
                    <div className='small-b'>
                        <div className='min'>
                            <img src={pn1} />
                            <div className='h hm'>Skills Validation Meet</div>
                        </div>
                    </div>
                    <div className='small-b'>
                        <div className='min'>
                        <img src={pn2} />
                        <div className='h1 hm'>Startup Visit</div>
                        
                        </div>
                    </div>
                    <div className='small-b'>
                        <div className='min'>
                        <img src={pn3} />
                        <div className='h2 hm'>E-summit</div>
                        </div>
                    </div>   
                </div>



                <div>
                </div>
                <div className='big-b'>
                    <div className='small-b'>
                        <div className='min'>
                            <img src={pn4} />
                            <div className='h3 hm'>Campus Workshop</div>
                        </div>
                    </div>
                    <div className='small-b'>
                        <div className='min'>
                        <img src={pn5} />
                        <div className='h4 hm'>Exhibtion</div>
                        
                        </div>
                    </div>
                    <div className='small-b'>
                        <div className='min'>
                        <img src={pn6} />
                        <div className='h5 hm'>Learning programs</div>
                        </div>
                    </div> 


                </div>
                





              




                


            </div>
        </div>
    );
}

export default Initative;
